// Empty base = same-origin relative API calls: the SPA talks to whatever host:port
// served it (Prod ncp.cash:443, Test :5000, Stage after DNS failover). No per-env build.
export const FRONT_URL = ''
export const BASE_URL = ''
